import React from 'react';
import getIconByName, { IconName } from '../../assets/icons';

export interface IconProps {
    style?: React.CSSProperties;
    icon: IconName;
    size?: number;
    /** When true, icons render smooth (no pixelation). Use for Apple-style app icons. */
    smooth?: boolean;
}

const Icon: React.FC<IconProps> = ({ icon, style, size, smooth }) => {
    const baseStyle = smooth
        ? { ...styles.iconSmooth, ...(size && { width: size, height: size, objectFit: 'contain' as const }) }
        : { ...styles.icon, ...(size && { width: size, height: size, objectFit: 'contain' as const }) };
    const iconStyle = Object.assign({}, baseStyle, style);
    return (
        <img
            style={iconStyle}
            alt={''}
            src={getIconByName(icon) as unknown as string}
        />
    );
};

const styles: StyleSheetCSS = {
    icon: {
        imageRendering: 'pixelated',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        pointerEvents: 'none',
    },
    iconSmooth: {
        imageRendering: 'auto',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        pointerEvents: 'none',
    },
};

export default Icon;
